import { Button, Icon } from '@lmc/ui-kit'
import Table from '@lmc/ui-kit/src/legacy/molecules/Table/Table'
import { NAMESPACE } from 'locale'
import { shiftPasswordsConstants } from 'locale/shiftPasswords'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import ShiftPasswordItem from './ShiftPasswordItem'

const ShiftPasswordsList = ({ onAdd, onDelete, shifts, testId }) => {
  const { t } = useTranslation(NAMESPACE.SHIFT_PASSWORDS)

  const rows = shifts?.map((shift) => ({
    actions: shift,
    duration: `${shift.length} ${
      shift.length === 1
        ? t(shiftPasswordsConstants.HOUR)
        : t(shiftPasswordsConstants.HOURS)
    }`,
    endTime: shift.endTime,
    key: shift.id,
    startTime: shift.startTime,
    title: shift.title
  }))

  const columns = [
    {
      dataIndex: 'title',
      title: t(shiftPasswordsConstants.TITLE)
    },
    {
      dataIndex: 'startTime',
      title: t(shiftPasswordsConstants.START_TIME)
    },
    {
      dataIndex: 'endTime',
      title: t(shiftPasswordsConstants.END_TIME)
    },
    {
      dataIndex: 'duration',
      title: t(shiftPasswordsConstants.ACCESS_DURATION)
    },
    {
      dataIndex: 'actions',
      title: t(shiftPasswordsConstants.ACTIONS),
      render: (shift, _row, index) => (
        <ShiftPasswordItem
          onDelete={onDelete}
          shift={shift}
          testId={testId ? `${testId}-item-${index}` : undefined}
        />
      )
    }
  ]

  return (
    <div data-testid={testId}>
      <Toolbar>
        <Button
          onClick={onAdd}
          variant="primary"
          icon={<Icon name="PlusOutlined" />}
          data-testid="add-shift-password-button"
        >
          {t(shiftPasswordsConstants.ADD_PASSWORD)}
        </Button>
      </Toolbar>
      <Table
        columns={columns}
        dataSource={rows}
        locale={{ emptyText: t(shiftPasswordsConstants.NO_PASSWORD_YET) }}
        pagination={{ hideOnSinglePage: true, pageSize: 10 }}
        data-testid={testId ? `${testId}-table` : undefined}
      />
    </div>
  )
}

const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`

ShiftPasswordsList.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  shifts: PropTypes.array
}

export default ShiftPasswordsList
